export class ExtraUserRegisterInvitation { // This combines 2 models: KitchenInvitationResponse + RegisterUserInvitationRequest
    id: string; // invitation id received in the email link
    name: string; // new user's name
    phoneNumber: string;
    password: string;
    email: string;
    restaurantName: string; // the one who invited the user on email
}